import { render } from "./PatientInformation.vue?vue&type=template&id=86947172&ts=true"
import script from "./PatientInformation.ts?vue&type=script&lang=ts&external"
export * from "./PatientInformation.ts?vue&type=script&lang=ts&external"

import "./PatientInformation.vue?vue&type=style&index=0&id=86947172&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__